import { useTranslation } from "react-i18next"
import { isImpersonating, endImpersonation } from "@/model/impersonation"
import { EyeIcon, CloseIcon } from "@shared/icons"

/**
 * Banner shown when admin is viewing the app as a user.
 * Displays at the top of the page with an option to end the session.
 */
export function ImpersonationBanner() {
  const { t } = useTranslation()

  if (!isImpersonating()) {
    return null
  }

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between gap-4 shadow-md">
      <div className="flex items-center gap-3 min-w-0">
        <EyeIcon
          className="h-5 w-5 shrink-0"
          size={20}
        />
        <span className="font-medium">{t("impersonation.viewing_as_user", "Viewing as user (admin mode)")}</span>
      </div>

      <button
        onClick={endImpersonation}
        className="shrink-0 px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white rounded text-sm font-medium transition-colors flex items-center gap-1"
      >
        <CloseIcon
          className="h-4 w-4"
          size={16}
        />
        {t("impersonation.end", "End")}
      </button>
    </div>
  )
}

export default ImpersonationBanner
